import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import { IconFileText, IconClipboardList, IconCheckCircle } from '../components/icons';

const Home = () => {
    const { t } = useI18n(['common', 'home']);
    
    return (
        <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
            <div className="bg-white rounded-lg shadow-md p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">
                        {t('welcome', { ns: 'home' })}
                    </h2>
                    <p className="text-gray-600 mb-6">{t('quickAccess', { ns: 'home' })}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* Form Applications */}
                    <Link 
                        to="/forms" 
                        className="block p-6 bg-blue-50 hover:bg-blue-100 rounded-lg border-2 border-blue-200 hover:border-blue-400 transition-all duration-200"
                    >
                        <div className="flex items-center mb-3">
                            <IconFileText className="w-8 h-8 text-blue-600 mr-3" />
                            <h3 className="text-xl font-semibold text-gray-900">{t('newForm', { ns: 'home' })}</h3>
                        </div>
                        <p className="text-gray-600">{t('newFormDesc', { ns: 'home' })}</p>
                    </Link>

                    {/* My Forms */}
                    <Link 
                        to="/forms/search" 
                        className="block p-6 bg-green-50 hover:bg-green-100 rounded-lg border-2 border-green-200 hover:border-green-400 transition-all duration-200"
                    >
                        <div className="flex items-center mb-3">
                            <IconClipboardList className="w-8 h-8 text-green-600 mr-3" />
                            <h3 className="text-xl font-semibold text-gray-900">{t('myForms', { ns: 'home' })}</h3>
                        </div>
                        <p className="text-gray-600">{t('myFormsDesc', { ns: 'home' })}</p>
                    </Link>

                    {/* Pending Approvals */}
                    <Link 
                        to="/forms/approval" 
                        className="block p-6 bg-orange-50 hover:bg-orange-100 rounded-lg border-2 border-orange-200 hover:border-orange-400 transition-all duration-200"
                    >
                        <div className="flex items-center mb-3">
                            <IconCheckCircle className="w-8 h-8 text-orange-600 mr-3" />
                            <h3 className="text-xl font-semibold text-gray-900">{t('pendingApprovals', { ns: 'home' })}</h3>
                        </div>
                        <p className="text-gray-600">{t('pendingApprovalsDesc', { ns: 'home' })}</p>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Home;
